
<script>
import { layoutMethods} from "@/state/helpers";
import Swal from "sweetalert2";
import { coreEloadSKUTestMethods  } from "@/state/helpers";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  page: {
    title: "E-Load SKU Test",
  },
  components: {
    Multiselect
  },
  data() {
    return {
      selectedSku: null,
      mobileNumber: "",
      inputAmount: 1,
      isLoading: false,
      showValidation: false,
      currentTestResult: null,
      testHistory: [],
      totalRecords: 0,
      currentPage: 1,
      perPage: 10,
      orderDesc: true,
      sort: 'id',
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      skuOptions: [{}],
      fields: [
        { 
          key: "created_at", 
          label: "Date/Time", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "provider_name", 
          label: "Provider Name", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "address", 
          label: "Mobile/Account Number", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "network_name", 
          label: "Network", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "sku_name", 
          label: "SKU Name", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "status", 
          label: "Status", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "reference_id", 
          label: "Reference ID", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "error_description", 
          label: "Error Description", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "epin", 
          label: "E-Pins", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
        { 
          key: "created_by", 
          label: "Requested By", 
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap'
        },
      ],
    };
  },
  computed: {
    filteredSkuOptions() {
      return this.skuOptions.map(sku => ({
        value: sku.value,
        text: `${sku.skuName} | Network: ${sku.networkName} | Provider: ${sku.serviceProviderName} | Status: ${sku.skuStatus}`,
      }));
    }
  },
  
  methods: {
    ...layoutMethods,
    ...coreEloadSKUTestMethods,
    handleSkuSelection(selectedOption) {
      this.selectedSku = selectedOption;
    },
    
    clearForm() {
      this.selectedSku = null;
      this.mobileNumber = "";
      this.inputAmount = 0;
      this.showValidation = false;
    },
    async confirmSendTestLoad() {
      this.showValidation = true;
      
      if (!this.selectedSku || !this.mobileNumber || (this.selectedSku.value.amount==0 && (!this.inputAmount || this.inputAmount ==0))) {
        this.$toast.showToast('danger', 'Validation Error', 'Please fill in all required fields');
        return;
      }
      
      // Show SweetAlert2 confirmation
      const result = await Swal.fire({
        title: 'Confirmation Test Load',
        icon: 'question',

        html: `You are about to send a test E-Load to </br><strong>${this.mobileNumber}</strong>. </br></br>Do you want to confirm it?`,
        showCancelButton: true,
        confirmButtonText: 'Yes, Send Test Load',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#E73092',
        cancelButtonColor: '#804997',
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: false,
        customClass: {
          popup: 'swal-custom-popup',
          confirmButton: 'swal-confirm-btn',
          cancelButton: 'swal-cancel-btn'
        }
      });

      if (result.isConfirmed) {
        await this.sendTestLoad();
      }
    },
    
    // Send test load
    async sendTestLoad() {
      this.isLoading = true;      
      try {
        if (!this.selectedSku || !this.selectedSku.value) {
          this.$toast.showToast('danger', 'Validation Error', 'Please select a valid SKU');
          return;
        }

        const payload = {
          action: 'buyLoad',
          params: {
            promoId: this.selectedSku.value.promoId,
            address: this.mobileNumber,
            amount: this.selectedSku.value.amount === 0 ? this.inputAmount : this.selectedSku.value.amount
          }
        };

        await this.actionCoreSKUTestAPIPOST(payload);
        
        await this.fetchLatestTestResults();
          
        await this.populateTestHistory();

        this.clearForm();
        
      } catch (error) {
          // On error, still fetch the latest result to show error details
          await this.fetchLatestTestResults();
          console.error("Error sending test load:", error);
      } finally {
        this.isLoading = false;
      }
    },
    
    // Refresh current test result
    async refreshTestResult() {
      if (this.currentTestResult && this.currentTestResult.status === 'pending') {
        await this.fetchLatestTestResults();
        await this.populateTestHistory();
      }
    },
    async fetchLatestTestResults() {
      await this.actionCoreSKUTestAPIPOST({
        action: "list",
        params: {
          page: 1,
          rows: 1,
          sort: "id",
          orderDesc: true,
        },
      }).then((response) => {
        const { status, message } = response;
        if (status === 'ok' && message?.rows?.length > 0) {
          const latestTest = message.rows[0];
          this.currentTestResult = {
            reference_id: latestTest.reference_id,
            address: latestTest.address,
            sku_name: latestTest.sku_name,
            network_name: latestTest.network_name,
            provider_name: latestTest.provider_name,
            epin: latestTest.epin || "--",
            error_description: latestTest.error_description || "--",
            status: latestTest.status
          };
        }

      }).catch((err) => {
        console.error("Error fetching latest test result:", err);
      });
    },
    async populateTestHistory() {
      await this.actionCoreSKUTestAPIPOST({
        action: "list",
        params: {
           page: this.currentPage,
            rows: this.perPage,
            sort: this.sort,
            orderDesc: this.orderDesc,
        },
      }).then((response)=>{
        const { status , message } = response;
        if(status == 'ok') {
          this.testHistory = message?.rows??[]
          this.totalRecords = message?.pageInfo.total ?? 0;
        }

      }).catch((err)=>{
        console.log("err", err);
      })
    },
    testHistorySort(ctx){
        this.sort = ctx.sortBy;
        this.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.populateTestHistory();
      },
  },
  async mounted() {
    this.changeTitle({ title: "E-Load SKU Test" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "E-Load Core Manager", to: { name: "" } },
        { text: "E-Load SKU Test", to: { name: "E-Load SKU Test" } },
      ],
    });
    
    await this.populateTestHistory();
    await this.fetchLatestTestResults();

    await this.actionCoreSKUTestAPIPOST({
        action: 'fetch-sku-data'
      }).then((res) => {
        this.skuOptions = res.message?.rows?.map(sku => ({
            value: sku,
            text: sku.skuName,
            skuName: sku.skuName,
            networkName: sku.networkName,
            serviceProviderName: sku.serviceProviderName,
            skuStatus: sku.skuStatus
          })) ?? [];
        
      }).catch((err) => {
        console.error("Error fetching SMS Campaign:", err);
        return;
      });
  },
};
</script>

<template>
  <div class="eload-sku-test-dashboard">
    <div class="row">
      <div class="col-12">
        <div class="bg-white">
          <div class="row g-0">
            <!-- Test Form Section -->
            <div class="col-lg-7 col-md-12 p-4">
              <form @submit.prevent="confirmSendTestLoad">
                <!-- SKU Name Field -->
                <div class="mb-3">
                  <label for="sku-name" class="form-label">
                    SKU Name <span class="text-danger">*</span>
                  </label>
                  <multiselect
                      v-model="selectedSku"
                      placeholder="Search and Select SKU Name"
                      :options="skuOptions"
                      :show-labels="false"
                      track-by="value"
                      :custom-label="option => option.skuName"
                      @input="handleSkuSelection"
                      :class="{ 'is-invalid': !selectedSku && showValidation }"
                    >
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                          <div class="mb-1">{{ props.option.skuName }}</div>
                          <small>
                            Network: {{ props.option.networkName }} | 
                            Provider: {{ props.option.serviceProviderName }} | 
                            Status: <span :class="props.option.skuStatus === 1 ? 'text-success' : 'text-danger'">
                              {{ props.option.skuStatus === 1 ? 'Active' : 'Inactive' }}
                            </span>
                          </small>
                        </div>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <div class="option__desc">
                          <div>{{ props.option.skuName }}</div>
                          <small>
                            Network: {{ props.option.networkName }} | 
                            Provider: {{ props.option.serviceProviderName }} | 
                            Status: <span :class="props.option.skuStatus === 1 ? 'text-success' : 'text-danger'">
                              {{ props.option.skuStatus === 1 ? 'Active' : 'Inactive' }}
                            </span>
                          </small>
                        </div>
                      </template>
                    </multiselect>
                  <div v-if="!selectedSku && showValidation" class="invalid-feedback">
                    This value is required
                  </div>
                </div>
                
                <!-- Mobile Number Field -->
                <div class="mb-4">
                  <label for="mobile-number" class="form-label">
                    {{ this.selectedSku ? this.selectedSku.value.addressType == 'MN' ? 'Mobile Number' : 'Account Number' : 'Mobile or Account Number' }} <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="mobile-number"
                    v-model="mobileNumber"
                    class="form-control"
                    :class="{ 'is-invalid': !mobileNumber && showValidation }"
                    :placeholder="this.selectedSku ? this.selectedSku.value.addressType == 'MN' ? 'Type Mobile Number' : 'Type Account Number' : 'Type Mobile or Account Number'"
                    :disabled="!selectedSku"
                    required
                  />
                  <div v-if="!mobileNumber && showValidation" class="invalid-feedback">
                    This value is required
                  </div>
                </div>

                <!-- Amount Field -->
                <div class="mb-4" v-if="selectedSku && selectedSku.value.amount == 0">
                  <label for="amount" class="form-label">
                    Amount <span class="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    v-model="inputAmount"
                    class="form-control"
                    :class="{ 'is-invalid': !inputAmount && showValidation }"
                    placeholder="Type Amount"
                    :disabled="!selectedSku"
                    min = "1"
                    onkeypress='return (event.charCode >= 48 && event.charCode <= 57) || event.charCode==46'
                    required
                  />
                  <div v-if="!inputAmount && showValidation" class="invalid-feedback">
                    This value is required
                  </div>
                </div>
                
                <!-- Action Buttons -->
                <div class="d-flex gap-2">
                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="isLoading"
                  >
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                    {{ isLoading ? 'Sending...' : 'Send Test Load' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="clearForm"
                    :disabled="isLoading"
                  >
                    Clear
                  </button>
                </div>
              </form>
            </div>
            
            <!-- Test Result Section -->
            <div class="col-lg-5 col-md-10 p-5">
              <div class="border border-neutral rounded-4 p-4">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <div class="d-flex align-items-center gap-2">
                    <span v-if="currentTestResult?.status" class="status-badge">
                      <span v-if="currentTestResult?.status === 'success'" class="text-success fw-bold">
                       <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99984 0.166664C4.40484 0.166664 0.666504 3.905 0.666504 8.5C0.666504 13.095 4.40484 16.8333 8.99984 16.8333C13.5948 16.8333 17.3332 13.095 17.3332 8.5C17.3332 3.905 13.5948 0.166664 8.99984 0.166664ZM7.334 12.1775L4.23984 9.09L5.4165 7.91L7.33234 9.8225L11.744 5.41083L12.9223 6.58916L7.334 12.1775Z" fill="#649644"/>
                        </svg>
                        Success
                      </span>
                      <span v-else-if="currentTestResult?.status === 'failed'" class="text-danger fw-bold">
                        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.99984 0.166626C4.40484 0.166626 0.666504 3.90496 0.666504 8.49996C0.666504 13.095 4.40484 16.8333 8.99984 16.8333C13.5948 16.8333 17.3332 13.095 17.3332 8.49996C17.3332 3.90496 13.5948 0.166626 8.99984 0.166626ZM12.5057 10.8275L11.3273 12.0058L8.99984 9.67829L6.67234 12.0058L5.494 10.8275L7.8215 8.49996L5.494 6.17246L6.67234 4.99413L8.99984 7.32163L11.3273 4.99413L12.5057 6.17246L10.1782 8.49996L12.5057 10.8275Z" fill="#C12928"/>
                        </svg>
                        Failed
                      </span>
                      <span v-else-if="currentTestResult?.status === 'pending'" class="text-warning">
                        Pending...
                      </span>
                    </span>
                    <span v-else class="text-muted">Status</span>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <button v-if="currentTestResult"
                      :class="['btn btn-link text-decoration-none p-0', currentTestResult?.status === 'pending' ? 'refresh-link' : 'refresh-link-muted']"
                      @click="refreshTestResult"
                      style="vertical-align: middle;"
                      :disabled="currentTestResult?.status !== 'pending'"
                    >

                    <svg
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.03366 10.8334C6.54477 10.8334 5.2781 10.3167 4.23366 9.28341C3.18921 8.25008 2.66699 6.98897 2.66699 5.50008V5.38342L1.60033 6.45008L0.666992 5.51675L3.33366 2.85008L6.00033 5.51675L5.06699 6.45008L4.00033 5.38342V5.50008C4.00033 6.61119 4.39199 7.55564 5.17533 8.33342C5.95866 9.11119 6.91144 9.50008 8.03366 9.50008C8.32255 9.50008 8.60588 9.46675 8.88366 9.40008C9.16144 9.33342 9.43366 9.23342 9.70033 9.10008L10.7003 10.1001C10.2781 10.3445 9.84477 10.5279 9.40033 10.6501C8.95588 10.7723 8.50033 10.8334 8.03366 10.8334ZM12.667 8.15008L10.0003 5.48341L10.9337 4.55008L12.0003 5.61675V5.50008C12.0003 4.38897 11.6087 3.44453 10.8253 2.66675C10.042 1.88897 9.08921 1.50008 7.96699 1.50008C7.6781 1.50008 7.39477 1.53341 7.11699 1.60008C6.83921 1.66675 6.56699 1.76675 6.30033 1.90008L5.30033 0.900081C5.72255 0.655637 6.15588 0.472304 6.60033 0.350081C7.04477 0.227859 7.50033 0.166748 7.96699 0.166748C9.45588 0.166748 10.7225 0.683415 11.767 1.71675C12.8114 2.75008 13.3337 4.01119 13.3337 5.50008V5.61675L14.4003 4.55008L15.3337 5.48341L12.667 8.15008Z"
                        :fill="currentTestResult?.status === 'pending' ? '#804997' : '#E1E1E1'"
                      />
                    </svg>
                    Refresh
                    </button>
                  </div>
                </div>
                
                <!-- Status Details -->
                <div class="test-result-details">
                  <div class="result-group mb-3">
                    <div class="d-flex align-items-center mb-3">
                      <span class="result-label fw-semi-bold">Reference ID:</span>
                      <span class="result-value">{{ currentTestResult?.reference_id || '--' }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="result-label fw-semi-bold">Mobile/Account Number:</span>
                      <span class="result-value">{{ currentTestResult?.address || '--' }}</span>
                    </div>
                  </div>
                  
                  <hr class="divider" />
                  
                  <div class="result-group">
                    <div class="d-flex align-items-center mb-2">
                      <span class="result-label">SKU Name:</span>
                      <span class="result-value">{{ currentTestResult?.sku_name || '--' }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <span class="result-label">Network:</span>
                      <span class="result-value">{{ currentTestResult?.network_name || '--' }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <span class="result-label">Provider Name:</span>
                      <span class="result-value">{{ currentTestResult?.provider_name || '--' }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-2">
                      <span class="result-label">E-Pins:</span>
                      <span class="result-value">{{ currentTestResult?.epin || '--' }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="result-label">Error Description:</span>
                      <span class="result-value">{{ currentTestResult?.error_description || '--' }}</span>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="table-responsive">
              <b-table
                :items="testHistory"
                :fields="fields"
                responsive="sm"
                class="table table-hover align-middle"
                tbody-tr-class="align-middle"
                head-variant="light"
                @sort-changed="testHistorySort"
              >
                <template #cell(created_at)="data">
                  <span>{{ data.item.created_at | customFormatDate('Asia/Manila', 'MMM D, YYYY [at] hh:mm A') }}</span>
                </template>
                <template #cell(status)="data">
                  <span 
                    :class="{
                      'text-success': data.item.status === 'success',
                      'text-danger': data.item.status === 'failed',
                      'text-warning': data.item.status === 'pending'
                    }"
                  >
                    {{ data.item.status ? (data.item.status.charAt(0).toUpperCase() + data.item.status.slice(1)) : '' }}
                  </span>
                </template>
                
                <template #cell(error_description)="data">
                  <span>{{ data.item.error_description || '' }}</span>
                </template>
                
                <template #cell(epin)="data">
                  <span>{{ data.item.epin || '' }}</span>
                </template>

                <template #cell(created_by)="data">
                  <span>{{ (data.item.created_by || '').replace('AzureAD-Peddlr-IDP_', '') }}</span>
                </template>
              </b-table>
            </div>
            
            <!-- No Data Message -->
            <div v-if="totalRecords === 0" class="text-center py-4">
              <span class="text-muted">No test history to display.</span>
            </div>
            
            <!-- Pagination -->
            <div class="row g-0 text-center text-sm-start" v-if="totalRecords > 10">
              <div class="col-sm-12">
                <div class="row align-items-center">
                  <div class="col-sm-6">
                    <div class="d-flex align-items-center">
                      <label class="me-2">Display:</label>
                      <b-form-select
                        v-model="perPage"
                        :options="pageOptions"
                        @change="populateTestHistory()"
                        class="form-select w-auto"
                        size="sm"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="d-flex justify-content-end">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRecords"
                        :per-page="perPage"
                        @input="populateTestHistory()"
                        class="pagination-rounded mb-0"
                        size="sm"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
/* Multiselect Customization */
.multiselect {
  min-height: 48px;
}

.multiselect__tags {
  min-height: 48px;
  padding: 8px 40px 0 12px;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
}

.multiselect__option--highlight {
  background: #E73092;
}

.multiselect--active .multiselect__tags {
  border-color: #E73092;
  border-radius: 8px 8px 0 0;
}

/* Result Section */
.result-label {
  min-width: 170px;
  font-weight: 600;
  margin-right: 1rem;
}

.result-value {
  word-break: break-word;
}

.divider {
  border-color: #E0E0E0;
  opacity: 1;
}

/* Status Badge */
.status-badge {
  font-size: 14px;
}

.status-badge i {
  font-size: 18px;
  margin-right: 6px;
}

.refresh-link {
  color: #804997;
}

.refresh-link-muted {
  color: #E1E1E1;
}


/* Table */
.table {
  width: 100%;
  min-width: 1000px;
}

@media (max-width: 991.98px) {
  .status-section {
    margin-top: 2rem;
  }
}
</style>
